import type { PropsWithChildren } from 'react'
import type { PERMISSIONS } from '../../constants'

import { useAuthorize } from './useAuthorize'
import { Allow } from './Allow'
import { Deny } from './Deny'

export type AuthorizeProps = {
  permissions: PERMISSIONS | PERMISSIONS[]
}

export function Authorize({
  permissions,
  children
}: PropsWithChildren<AuthorizeProps>) {
  const isAuthorized = useAuthorize({
    permissions
  })

  if (permissions?.length === 0 || isAuthorized) {
    return <Allow>{children}</Allow>
  }

  return <Deny />
}
